<template>
    <div class="p-3">
        <h3>RL 3.13 Rekapitulasi Kegiatan Rehabilitasi Medik</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Daftar Kegitan Rehabilitasi Medik" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-rehabilitasi-medik',
                groupBy: 'section',
                columns: [
                    {
                        title: 'No',
                        field: 'id',
                        width: 50,
                        hozAlign: 'center',
                    },
                    {
                        title: 'Jenis Tindakan',
                        field: 'description',
                        width: 250,
                    },
                    {
                        title: 'Jumlah',
                        field: 'value',
                        widthGrow: 1,
                        editor: 'input', // Make editable if needed
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
    methods: {
        openDetailPage(e, cell) {
            const data = cell.getRow().getData()
            const regno = data.Regno

            this.$router.push({
                name: 'konsul_antar_poli_detail',
                params: { Regno: regno }
            })
        },
    }
}
</script>
